import "./CustomProgressBar.scss"

import { Icon, ProgressBar } from "@shopify/polaris"
import { CheckIcon } from "polaris-enhance"

export interface IProgressBar {
  step: number
  stepCount: number
}

export default function CustomProgressBar({ step, stepCount }: IProgressBar) {
  const isComplete = stepCount > 0 && step >= stepCount
  const progress = stepCount > 0 ? (step / stepCount) * 100 : 0

  return (
    <div className="flex items-center gap-4">
      <div className="progress-title whitespace-nowrap">
        {isComplete ? (
          <div className="flex items-center">
            <Icon source={CheckIcon} tone={"base"} />
            {t("AllTasksComplete")}
          </div>
        ) : (
          <>
            {t("StepOfStepcountTasksComplete", {
              replace: { step, stepCount },
            })}
          </>
        )}
      </div>
      <div className="flex-1">
        <ProgressBar
          progress={progress}
          size="small"
          tone={isComplete ? "success" : "primary"}
        />
      </div>
    </div>
  )
}
